import { DialogContent } from '@reach/dialog'
import PropTypes from 'prop-types'
import { lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { CSSTransition } from "react-transition-group"

import Spinner from '@/components/Spinner'
import { hasEmptyCartSelector } from '@/selectors'

import Header from '../Header'

const EmptyCart = lazy(() => import('../../EmptyCart'))
const CartItems = lazy(() => import('../../CartItems'))
const Checkout = lazy(() => import('../../Checkout'))

const TRANSITION_TIMEOUT = 400

const Content = ({ onDismiss, isShowing }) => {
  const hasEmptyCart = useSelector(hasEmptyCartSelector)
  const dialogContentStyles = hasEmptyCart ? 'has-empty-cart' : undefined

  return (
    <div className='mini-cart-content-wrap'>
      <CSSTransition
        appear
        classNames="mini-cart-transition"
        in={isShowing}
        timeout={TRANSITION_TIMEOUT}
      >
        <DialogContent
          aria-labelledby='mini-cart-heading'
          className={`mini-cart-reach-dialog-content ${dialogContentStyles}`}
        >
          <div className='mini-cart mini-cart__modal-content'>
            <Header onDismiss={onDismiss} />
            <Choose>
              <When condition={hasEmptyCart}>
                <Suspense fallback={<Spinner />}>
                  <EmptyCart />
                </Suspense>
              </When>
              <Otherwise>
                <Suspense fallback={<Spinner />}>
                  <div className='cart-content-scroll-container'>
                    <CartItems />
                  </div>
                  <Checkout />
                </Suspense>
              </Otherwise>
            </Choose>
          </div>
        </DialogContent>
      </CSSTransition>
    </div>
  )
}

export default Content

Content.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired
}
